<template>
  <div class="map--results">
    <div v-if="!this.isLoading && this.$route.name === 'map'">
      <div v-if="locations.length === 0" class="map-details-empty">
        <map-details-empty-state />
      </div>
      <div v-if="locations.length >= 1">
        <ul :class="alertsActive ? 'list-unstyled-alerts-active' : 'list-unstyled'">
          <li v-for="(location, location_index) in alphaLocations" :key="`ptg-${location_index}`"
            class="location-info-map" :class="
              selectedLocation && location.slug === selectedLocation.slug
                ? 'active-pin'
                : ''
            " :ref="`loc-${location.slug}`">
            <div>
              <div class="li-container" :class="$route.name === 'trip-details' ? 'trip-details' : ''">
                <UserFavorite parent="places-to-go" :objectid="location.id" :index="location_index"
                  :slug="location.slug" class="user-favorite-component" />
                <div class="list-wrapper">
                  <div @click="setSelected(location)" class="list-left-data">
                    <span @click="closeMenu()" class="map--loc-type">{{
                      location.type
                      .replace(/([A-Z]+)/g, ' $1')
                      .replace(/^/, '')
                      .trim()
                      .toUpperCase()
                      }}</span>
                    <h2>
                      <router-link v-if="location.eventStartDate" :to="`/upcoming-events/${location.slug}`"
                        class="list-location">{{ location.name }}</router-link>
                      <router-link v-else :to="`/places-to-go/${location.slug}`" class="list-location">{{ location.name
                        }}
                      </router-link>
                    </h2>
                    <div class="address-wrapper">
                      <img :ref="location.id" :class="location.favoritedLoc ? 'fav-class' : ''" class="map-icon-place"
                        src="/images/icons/map-pin-alabama.svg" />
                      <span @click="closeMenu()" class="map--loc-add">
                        {{
                        location.address ? location.address : location.address1
                        }}<br />
                        {{ location.city }}, AL {{ location.zip }}</span>
                    </div>
                    <span v-if="location.telephone" class="phone">
                      <img class="map-icon-phone" src="/images/icons/phone.svg" />
                      {{
                      location.telephone
                      .replace(/^\+1/, '')
                      .replace(/\D/g, '')
                      .replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 - $3')
                      }}
                    </span>
                  </div>
                  <div class="activity-wrapper">
                    <div class="icons-wrapper">
                      <EventIcon v-for="(
                          experience_type, experience_index
                        ) in location.experience_types" :key="`ex-${experience_index}`"
                        :eventTypeIds="[experience_type]" class="icons-experience-type" />
                      <div v-for="(badge, badge_index) in location.badges" :key="`bg-${badge_index}`">
                        <img :src="badge.imageUrl" class="badges-icons" />
                      </div>
                    </div>
                    <div class="activities-container" v-if="location.activities && location.activities.length > 0">
                      <h3 class="activity-title">Activities</h3>
                      <div v-for="(activity, activity_index) in location.activities" :key="`act-${activity_index}`">
                        <span v-if="location_index !== location.activities.length - 1" class="activity-text">{{
                          activity.name }},&nbsp;</span>
                        <span v-else class="activity-text">{{
                          activity.name
                          }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div v-if="isMobile" :class="pagingClass" class="col-lg-12 paging">
        <div class="row no-gutters">
          <div class="col-lg-9 col-8">
            <div class="text-left featured">
              {{ results_title }}
            </div>
            <div class="text-left page-info">
              Viewing {{ resultSet }} of {{ totalLocationsCount }} Results
            </div>
          </div>
          <div class="col-lg-3 col-4 text-right paging-buttons">
            <span v-if="currentPage > 1" @click="prevPage()">
              <IconBase variant="arrow-long-left" size="24" color="" classes="list-buttons ml-2" />
            </span>
            <span v-if="currentPage < totalPages" @click="nextPage()">
              <IconBase variant="arrow-long-right" size="24" color="" classes="list-buttons ml-2" />
            </span>
          </div>
        </div>
      </div>
      <div v-else :class="pagingClass" class="col-lg-12 paging paging-fixed">
        <div class=" row no-gutters">
          <div class="col-lg-9 col-8">
            <div class="text-left featured">
              {{ results_title }}
            </div>
            <div class="text-left page-info">
              Viewing {{ resultSet }} of {{ totalLocationsCount }} Results
            </div>
          </div>
          <div class="col-lg-3 col-4 text-right paging-buttons">
            <span v-if="currentPage > 1" @click="prevPage()">
              <IconBase variant="arrow-long-left" size="24" color="" classes="list-buttons ml-2" />
            </span>
            <span v-if="currentPage < totalPages" @click="nextPage()">
              <IconBase variant="arrow-long-right" size="24" color="" classes="list-buttons ml-2" />
            </span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="this.myTripsLoaded && this.$route.name === 'trip-details'">
      <div v-if="
          pin.length === 1 ||
          (pin.length <= 2 && pin.some((p) => p.begin === true))
        " class="trip-details-empty">
        <trip-details-empty-state />
      </div>
      <ul v-if="pin.length >= 2" :class="
          alertsActive
            ? 'list-unstyled-alerts-active-trip-details'
            : 'list-unstyled-trip-details'
        ">
        <li v-for="(location, location_index) in pin.filter(
            (p) => p.slug !== undefined
          )" :key="`td-${location_index}`" :class="
            selectedLocation && location.slug === selectedLocation.slug
              ? 'active-pin'
              : ''
          " :ref="`loc-${location.slug}`">
          <div class="location-info">
            <div class="li-container" :class="$route.name === 'trip-details' ? 'trip-details' : ''">
              <div class="list-wrapper">
                <div @click="setSelected(location)" class="list-left-data">
                  <span @click="closeMenu()" class="map--loc-type">{{
                    location.type
                    .replace(/([A-Z]+)/g, ' $1')
                    .replace(/^/, '')
                    .trim()
                    .toUpperCase()
                    }}</span>
                  <h2>
                    <router-link v-if="location.eventStartDate" :to="`/upcoming-events/${location.slug}`"
                      class="list-location">{{ location.name }}</router-link>
                    <router-link v-else :to="`/places-to-go/${location.slug}`" class="list-location">{{ location.name }}
                    </router-link>
                  </h2>
                  <div class="address-wrapper">
                    <img :ref="location.id" :class="location.favoritedLoc ? 'fav-class' : ''" class="map-icon-place"
                      src="/images/icons/map-pin-alabama.svg" />
                    <span @click="closeMenu()" class="map--loc-add">
                      {{
                      location.address ? location.address : location.address1
                      }}<br />
                      {{ location.city }}, AL {{ location.zip }}</span>
                  </div>
                  <span v-if="location.telephone" class="phone">
                    <img class="map-icon-phone" src="/images/icons/phone.svg" />
                    {{
                    location.telephone
                    .replace(/^\+1/, '')
                    .replace(/\D/g, '')
                    .replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2-$3')
                    }}
                  </span>
                </div>
                <div class="activity-wrapper">
                  <div class="icons-wrapper">
                    <EventIcon v-for="(
                        experience_type, experience_index
                      ) in location.experience_types" :key="`exp-${experience_index}`"
                      :eventTypeIds="[experience_type]" class="icons-experience-type" />
                    <div v-for="(badge, badge_index) in location.badges" :key="`bdg-${badge_index}`">
                      <img :src="badge.imageUrl" class="badges-icons" />
                    </div>
                  </div>
                  <div class="activities-container" v-if="location.activities && location.activities.length > 0">
                    <h3 class="activity-title">Activities</h3>
                    <div v-for="(activity, activity_index) in location.activities" :key="`ac-${activity_index}`">
                      <span v-if="activity_index !== location.activities.length - 1" class="activity-text">{{
                        activity.name }},&nbsp;</span>
                      <span v-else class="activity-text">{{
                        activity.name
                        }}</span>
                    </div>
                  </div>
                </div>
                <div class="toggle-container">
                  <div class="toggle-tx col-9">
                    Show In Route<br />
                    <b-form-checkbox @change="togglePin(location.id)" :checked="location.show" name="check-button"
                      id="showInRoute" class="show-in-route-toggle" switch>
                    </b-form-checkbox>
                  </div>
                  <div class="trash-icon col-3">
                    <delete-location :myTrips="myTrips" :objectid="location.id" :index="location_index" :locs="pin"
                      :slug="location.slug" :name="location.name" :tripId="tripId" />
                  </div>
                </div>
              </div>
            </div>
            <div class="toggle-container-mobile">
              <div>
                <div class="col delete-location-icon">
                  <delete-location :myTrips="myTrips" :objectid="location.id" :index="location_index" :locs="pin"
                    :slug="location.slug" :name="location.name" :tripId="tripId" class="" />
                </div>
                <div class="col toggle-tx">
                  Show In Route<br />
                  <b-form-checkbox @change="togglePin(location.id)" :checked="location.show" name="check-button"
                    id="showInRoute" class="show-in-route-toggle" switch>
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Watch } from 'vue-property-decorator';
import { Auth } from 'aws-amplify';
import UserFavorite from '@/components/Common/UserFavorite.vue';
import EventIcon from '@/components/Events/EventIcon.vue';
import TripDetailsEmptyState from '@/components/MyTrips/TripDetailsEmptyState.vue';
import MapDetailsEmptyState from '@/components/Maps/MapDetailsEmptyState.vue';
import { mapActions, mapGetters } from 'vuex';
import IconBase from '@/components/Common/icons/index.vue';
import DeleteLocation from './DeleteLocation.vue';

@Component({
  components: {
    UserFavorite,
    DeleteLocation,
    EventIcon,
    TripDetailsEmptyState,
    MapDetailsEmptyState,
    IconBase,
  },
  props: {
    tripId: {
      type: String,
    },
    pin: {
      type: Array,
      default: () => [],
    },
    objectid: {
      type: String,
    },
    locations: {
      type: Array,
    },
    results_title: {
      type: String,
    },
  },
  data() {
    return {
      favorited: [],
      myTripLocations: [],
      userId: '',
      alertsActive: false,
      locationPins: null,
      locationsPaged: null,
      alphaLocations: null,
      locationsPagedPins: null,
      perPage: 25,
      page: 1,
      pagingClass: 'paging-sticky',
      resultSet: null,
      currentPage: 1,
      totalPages: null,
      totalLocationsCount: null,
      lowerResultBound: 0,
      upperResultBound: 25,
      hoverColor: 'green',
    };
  },
  created() {
    setTimeout(() => {
      if (this.hasAlerts) {
        this.alertsActive = true;
      }
    }, 100);
  },
  methods: {
    ...mapActions({
      editTrip: 'myTrips/editTrip',
    }),
    changeColor(color) {
      this.hoverColor = color;
    },
    nextPage() {
      this.$store.dispatch('maps/setHoveredLocation', null);
      const existingPage = this.page;
      this.page++;
      this.currentPage = this.page;
      if (this.perPage * this.page > this.locations.length) {
        this.resultSet = `${this.perPage * existingPage} - ${this.locations.length}`;

        const hyphenIndex = this.resultSet.indexOf('-');
        if (hyphenIndex !== -1) {
          this.lowerResultBound = parseInt(
            this.resultSet.slice(0, hyphenIndex),
            10,
          );
          this.upperResultBound = parseInt(
            this.resultSet.slice(hyphenIndex + 1),
            10,
          );
        } else {
          console.log('Hyphen not found in resultSet');
        }
      } else {
        this.resultSet = `${this.perPage * existingPage} - ${
          this.perPage * this.page
        }`;

        const hyphenIndex = this.resultSet.indexOf('-');
        if (hyphenIndex !== -1) {
          this.lowerResultBound = parseInt(
            this.resultSet.slice(0, hyphenIndex),
            10,
          );
          this.upperResultBound = parseInt(
            this.resultSet.slice(hyphenIndex + 1),
            10,
          );
        } else {
          console.log('Hyphen not found in resultSet');
        }
      }
      this.locationsPaged = this.locations.slice(
        this.perPage * existingPage,
        this.perPage * this.page,
      );
      this.alphaLocations = this.locationsPaged.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
      this.locationsPagedPins = this.locationPins.slice(
        this.perPage * existingPage,
        this.perPage * this.page,
      );
      this.$root.$emit('updateLocationsPagedPins', this.locationsPagedPins);
      if (this.page === this.totalPages && this.locationsPaged.length < 6) {
        this.pagingClass = 'paging-absolute';
      }
    },
    prevPage() {
      this.$store.dispatch('maps/setHoveredLocation', null);
      this.page--;
      this.currentPage = this.page;
      if (this.page === 1) {
        this.resultSet = `1 - ${this.perPage * this.page}`;

        const hyphenIndex = this.resultSet.indexOf('-');
        if (hyphenIndex !== -1) {
          this.lowerResultBound = parseInt(
            this.resultSet.slice(0, hyphenIndex),
            10,
          );
          this.upperResultBound = parseInt(
            this.resultSet.slice(hyphenIndex + 1),
            10,
          );
        } else {
          console.log('Hyphen not found in resultSet');
        }

        this.locationsPaged = this.locations.slice(0, this.perPage * this.page);
        this.$root.$emit('updateLocationsPagedPins', this.locationsPagedPins);
        this.alphaLocations = this.locationsPaged.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
        this.locationsPagedPins = this.locationPins.slice(
          0,
          this.perPage * this.page,
        );
        this.$root.$emit('updateLocationsPagedPins', this.locationsPagedPins);
      } else {
        this.resultSet = `${this.perPage * (this.page - 1)} - ${
          this.perPage * this.page
        }`;

        const hyphenIndex = this.resultSet.indexOf('-');
        if (hyphenIndex !== -1) {
          this.lowerResultBound = parseInt(
            this.resultSet.slice(0, hyphenIndex),
            10,
          );
          this.upperResultBound = parseInt(
            this.resultSet.slice(hyphenIndex + 1),
            10,
          );
        } else {
          console.log('Hyphen not found in resultSet');
        }

        this.locationsPaged = this.locations.slice(
          this.perPage * (this.page - 1),
          this.perPage * this.page,
        );
        this.alphaLocations = this.locationsPaged.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
        this.locationsPagedPins = this.locationPins.slice(
          this.perPage * (this.page - 1),
          this.perPage * this.page,
        );
        this.$root.$emit('updateLocationsPagedPins', this.locationsPagedPins);
      }
      if (this.page !== this.totalPages && this.locationsPaged.length > 4) {
        this.pagingClass = 'paging-sticky';
      }
    },
    mq() {
      const chatStyle = document.querySelector('.a5-widget-container');
      this.width = document.documentElement.clientWidth;
      if (this.width < 930) {
        this.isMobile = true;
        if (chatStyle && chatStyle.style !== null) {
          chatStyle.style.display = 'none';
        }
      } else {
        this.isMobile = false;
        if (chatStyle && chatStyle.style !== null) {
          chatStyle.style.display = 'block';
        }
      }
    },
    async setSelected(location) {
      await this.$store.dispatch('maps/setSelectedLocation', location);
    },
    async closeMenu() {
      this.$emit('locationSelected');
    },
    selectedLocation() {
      return this.$store.state.maps.selectedLocation;
    },
    async togglePin(id) {
      try {
        const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
        const trip = await this.getTripById(this.tripId);
        const updateShow = trip.tripInfo.map((info) => {
          if (info.locationId === id) {
            return { ...info, show: !info.show };
          }
          return info;
        });
        const updatedTrip = {
          owner: user.username,
          tripId: trip.tripId,
          name: trip.name,
          locations: trip.locations,
          routing: {
            begin: {
              lat: trip.routing.begin.lat,
              long: trip.routing.begin.long,
              city: trip.routing.begin.city,
              state: trip.routing.begin.state,
            },
            end: {
              lat: trip.routing.end.lat,
              long: trip.routing.end.long,
              city: trip.routing.end.city,
              state: trip.routing.end.state,
            },
          },
          tripInfo: updateShow,
        };
        await this.editTrip(updatedTrip);
        // Remove waypoint from map
        setTimeout(() => {
          this.$root.$emit('updateWaypoints');
        }, 100);
      } catch (error) {
        console.log('Show property not updated', error);
      }
    },
    handleScroll() {
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
        this.divHeight = '65px';
      }
    },
  },
  computed: {
    ...mapGetters({
      hasTrips: 'myTrips/hasTrips',
      myTrips: 'myTrips/myTrips',
      myTripsLoaded: 'myTrips/loaded',
      getTripById: 'myTrips/getTripById',
      uniqueLocations: 'myTrips/getUniqueLocations',
      hasAlerts: 'alerts/hasAlerts',
      isLoading: 'maps/isLoading',
    }),
  },
  mounted() {
    this.mq();
    window.addEventListener('resize', this.mq);
  },
})
class MapList extends Vue {
  @Watch('locations', { immediate: true, deep: false })
  locationsupdated() {
    if (this.locations) {
      this.$nextTick(() => {
        this.locationPins = this.locations.map((l) => ({
          id: l.id,
          position: {
            lat: parseFloat(l.latitude),
            lng: parseFloat(l.longitude),
          },
          type: l.type,
          name: l.name,
          address: l.address,
          city: l.city,
          zip: l.zip,
          slug: l.slug,
          show: true,
        }));
        this.totalPages = Math.ceil(this.locations.length / this.perPage);
        this.locationsPaged = this.locations.slice(0, 25);
        this.alphaLocations = this.locationsPaged.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
        this.locationsPagedPins = this.locationPins.slice(0, 25);
        // emit locationsPagedPins to Map.vue
        this.$root.$emit('updateLocationsPagedPins', this.locationsPagedPins);
        if (this.locations.length < 25) {
          this.resultSet = this.locations.length;
        } else {
          this.resultSet = '1-25';
        }
        this.totalLocationsCount = this.locations.length;
      });
    }
  }
}

export default MapList;
</script>

<style lang="scss" scoped>
.toggle-tx {
  font-family: 'IdealSans-Bold';
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--dark-blue-300);
  padding: 0;
  margin-right: 7px;
  margin-top: 5px;
}

.pin-toggle {
  margin-top: -5px;
  margin-right: 25px;
}

.show-in-route-toggle {
  margin-left: -45px;
}

.list-wrapper {
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: 1024px) {
    flex-direction: row;
  }
}

.list-left-data {
  padding-left: 0px;
  text-align: left;
  width: 100%;

  @media only screen and (min-width: 1024px) {
    padding-left: 10px;
    width: 48%;
  }

  @media only screen and (min-width: 1800px) {
    width: 50%;
  }
}

button.btn-fav-add {
  height: 60px !important;
}

.activity-wrapper {
  margin-top: 10px;
  width: 100%;

  @media only screen and (min-width: 1024px) {
    margin-top: 10px;
    width: 34%;
  }
}

.activity-title {
  color: #173945;
  font-size: 12px;
  margin: 0;
  width: 100%;
}

.activity-text {
  color: #173945;
  font-family: 'IdealSans-Book';
  font-size: 12px;
  font-weight: normal;
}

.address-wrapper {
  align-content: center;
  align-items: center;
  display: flex;
  justify-content: flex-start;

  @media only screen and (min-width: 1024px) {
    margin-left: 8px;
  }
}

.map-icon-place {
  height: 20px;
  margin-right: 14px;
  width: 14px;
}

.fav-class {
  filter: invert(63%) sepia(50%) saturate(2603%) hue-rotate(328deg)
    brightness(89%) contrast(89%);
}

.map-icon-phone {
  height: 18px;
  margin-right: 14px;
  width: 15px;
}

.phone {
  align-items: center;
  display: flex;
  flex-direction: row;
  font-family: 'IdealSans-Medium';
  font-size: 14px;
  font-weight: bold;
  padding-top: 10px;

  @media only screen and (min-width: 1024px) {
    margin-left: 8px;
  }
}

.icons-wrapper {
  align-content: center;
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-bottom: 10px;
  padding-right: 25px;

  @media only screen and (min-width: 1024px) {
    width: 215px;
  }

  @media only screen and (min-width: 1366px) {
    width: 250px;
  }
}

.icons-experience-type {
  height: 40px;
  margin: 0 15px 10px 0;
  width: 42px;

  @media only screen and (min-width: 1024px) {
    height: 30px;
    width: 32px;
  }

  @media only screen and (min-width: 1366px) {
    height: 40px;
    width: 42px;
  }
}

.location-info {
  display: flex;
  flex-direction: row;
  min-width: 100%;
}

.location-info:hover,
.location-info-map:hover {
  background-color: #f6f6f6;
}

.activities-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 250px;

  @media only screen and (min-width: 1728px) {
    // max-width: 300px;
  }
}
.toggle-container {
  display: none;

  @media only screen and (min-width: 1024px) {
    display: flex;
    flex-direction: row;
    width: 14%;
    min-width: 120px;
  }
}

.toggle-container-mobile {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 20px;
  border-bottom: 1px solid #4e97b2;

  @media only screen and (min-width: 1024px) {
    display: none;
  }
}

.delete-location-icon {
  margin-left: 35px;
  margin-bottom: 25px;
}

.icons-experience {
  height: 45px;
  width: 44px;
}

.badges-icons {
  height: 40px;
  margin: 0 15px 10px 0;
  width: 42px;

  @media only screen and (min-width: 1024px) {
    height: 30px;
    width: 32px;
  }

  @media only screen and (min-width: 1024px) {
    height: 40px;
    width: 42px;
  }
}

.list-unstyled,
.list-unstyled-alerts-active,
.list-unstyled-alerts-active-trip-details,
.list-unstyled-trip-details {
  padding-left: 10px;
  height: calc(100vh - 150px);
  overflow-x: hidden;
  overflow-y: scroll;
  position: relative;
  top: 0px;
}

.list-unstyled-trip-details {
  height: calc(100vh - 275px);

  @media only screen and (min-width: 800px) {
    height: calc(100vh);
  }
}

.list-unstyled-alerts-active {
  top: 30px;
}

ul.list-unstyled li div.li-container,
ul.list-unstyled-alerts-active li div.li-container,
ul.list-unstyled-alerts-active-trip-details li div.li-container,
ul.list-unstyled-trip-details li div.li-container {
  border-bottom: 1px solid #4e97b2;
  margin-left: 18px;
  padding: 30px 0px;
  position: relative;

  @media only screen and (min-width: 1024px) {
    margin-left: 20px;
    margin-right: 20px;
  }

  @media only screen and (min-width: 1180px) {
    margin-left: 40px;
    margin-right: 40px;
  }
}

ul.list-unstyled-alerts-active li div.li-container {
  @media only screen and (min-width: 1024px) {
    top: 0px;
  }
}

.li-container:hover {
  background-color: #f6f6f6;
}

.user-favorite-component {
  padding-top: 20px;
}

.fav-wrapper {
  left: initial;
  position: absolute;
  right: 30px;
  top: 5px;
}

button.btn-fav-minus,
button.btn-fav-plus {
  height: 45px;
  min-height: 45px;
  width: 28px;
}

.card {
  background-color: transparent !important;
  border-radius: 0px !important;
}

.map--results {
  left: 0;
  position: relative;
  top: 20px;
}

.tablist > .card.mb-1 {
  margin-bottom: 0px !important;
}

h2 {
  line-height: 0.75;
  margin: 0 25px 14px 0px;
}

a {
  color: #173945;
  font-size: 1.4rem;
  text-decoration: underline;
}

.card-header:first-child {
  border-radius: none !important;
}

li {
  background-color: transparent;
  cursor: pointer;
}

// li:hover {
//   background-color: #f6f6f6;
// }

li span {
  display: block;
}

li.active {
  border: 2px solid #4e97b2;
}

.map--loc-type {
  color: #6c767f;
  font-size: 10px;
  margin-bottom: 0px;

  @media only screen and (min-width: 1024px) {
    font-size: 12px;
  }
}

.map--loc-add {
  font-size: 13px;
  line-height: 18px;
}

.active-pin {
  border-color: red;
}

a.list-location {
  font-size: 16px;
  text-decoration: none;

  @media only screen and (min-width: 1024px) {
    font-size: 18px;
  }
}

.icons-address {
  height: 8px;
  width: 5px;
}

.map-details-empty {
  width: 100%;
}

.trip-details {
  width: 65%;

  @media only screen and (min-width: 1024px) {
    width: 45%;
  }
}

.trip-details-empty {
  width: 100%;

  @media only screen and (min-width: 1024px) {
    width: 50%;
  }
}

/* Paging Styles */
.paging {
  background-color: #173945;
  padding: 10px 10px 20px 35px;
  z-index: 9999999;
  height: 6rem;
  @media only screen and (min-width: 1024px) {
    // height: auto;
  }
}
.paging-sticky {
  bottom: 0 !important;
  position: sticky;
}
.paging-absolute {
  bottom: 0 !important;
  position: absolute;
}
.featured {
  color: white;
  font-weight: 700;
  padding-top: 10px;
  line-height: 18px;
}
.page-info {
  color: white;
  font-size: 16px;
  z-index: 9999;
}
.paging-buttons {
  fill: #ffffff;
  padding-right: 20px;
  padding-top: 8px;
}
.list-buttons {
  display: inline-block;
}
.list-buttons:hover {
  cursor: pointer;
}
.paging-buttons span:hover {
  fill: orange;
}
</style>
